<template>
    <div class="pa-0 ma-0">
        <!--Parte visible del componente-->
        <tr>

            <td style=""><div>{{item.nombre}}</div></td>             
            <td style=""><div>{{item.comprados}}</div></td>
            <td style=""><div>{{item.usados}}</div></td>
            <td style=""><div>{{item.timbres_disponibles}}</div></td>
            <td style=""><div>{{item.ultimo}}</div></td>


            <td >
                <div class="tblOpciones">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                            <v-btn v-on="on" class="botonHover" icon fab dark small @click="detalle()">
                                <v-icon class="iconoDelgadoBoton" v-text="'$visibility_outline'"></v-icon>
                            </v-btn>
                        </template>
                        <span>Ver</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                        <v-btn v-on="on" icon fab dark small @click="isOpen ? isOpen = false:isOpen = true">
                            <v-icon class="tamIconoBoton iconoDelgadoBoton">{{isOpen ? 'keyboard_arrow_up':'keyboard_arrow_down'}}</v-icon>
                        </v-btn>
                        </template>
                        <span>Desplegar</span>
                    </v-tooltip>
                </div>
            </td>
        </tr>


        <!--Parte desplegable del componente-->
        <template v-if="isOpen">
            <tr class="td-titles">
                <td>
                    <div>
                        Razón social
                    </div>
                </td>
                <td>
                    <div>
                        RFC
                    </div>
                </td>
                <td>
                    <div>
                        Régimen fiscal
                    </div>
                </td>
                <td>
                    <div>
                        Uso CFDI
                    </div>
                </td>
                <td >
                    <div class="tblOpciones">
                        Opciones
                    </div>
                </td>
            </tr>
            <tr :key="datos.id" v-for="datos in facturacion"  class="td-short">
                               
                <td>
                    <div>
                        {{datos.razon_social}}
                    </div>
                </td>
                <td>
                    <div>
                        {{datos.rfc}}
                    </div>
                </td>
                <td>
                    <div>
                        {{datos.regimen}}
                    </div>
                </td>
                <td>
                    <div>
                        {{datos.uso_cfdi}}
                    </div>
                </td>
                
                <td style="padding-left:8px; padding-right:8px;">
                    <div class="tblOpciones">
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn v-on="on" class="botonHover" icon fab dark small @click="abrirModal(datos)">
                                    <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                                </v-btn>
                            </template>
                            <span>Editar</span>
                        </v-tooltip>
                        <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                                <v-btn  v-on="on" class="botonHover" icon fab small @click="pagar(datos)">
                                    <v-icon class="tamIconoBoton outlined_v_icon" color="#96999A">shopping_cart</v-icon>
                                </v-btn>
                            </template>
                            <span>Comprar</span>
                        </v-tooltip>
                    </div>
                </td>
            </tr>
        </template>
    </div>
</template>


<script>
import GetUrlImg from "@/plugins/Urlimagen";
import moment from 'moment';
moment.locale('es');

export default {
    name: 'expandable-item',
    props: {
        item: {
            type: Object,
            required: true,
            default: ''
        },
        full: {
            type: Boolean,
            default: true
        },
    },
    data() {
        return {
            isOpen: false,
            urlImg : '',
        }
    },
    computed: {
        facturacion(){
            return this.item.facturacion;
        }
    },
    methods: {
        detalle(){
            this.$emit("detalle", this.item)
        },
        abrirModal(data){
            this.$emit("abrirModalUpdate", data);
        },
        pagar(data){
            this.$emit("pagar", data);
        }
        
        
    },
    //MOUNTED se ejecutan instrucciones una vez se crea el componente;
    mounted () {
        this.urlImg = GetUrlImg.getURL();
    },
}
</script>

<style scoped>
    table {
        border-collapse: collapse;
        width: 100%;
        overflow-x: scroll;
    }
    th{
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 500;
        font-size: 16px;
        line-height: 20px;
        text-align: left;
        color: #828282;
        background-color: #f6f5f6;
        padding: 13px 45px 13px 45px;
    }
    th > div{
        max-width: 15rem;
        text-align: center;
        margin-right: auto;
        margin-left: auto;
    }
    td{
        font-family: "Montserrat";
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 17px;
        text-align: left;
        color: #1E2245;
        background-color: #fdfcfc;
        padding: 13px 45px 13px 45px;
        letter-spacing: -0.34px;
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        max-width: 15rem;
    }

    td > div{
        overflow: hidden;
        text-overflow: ellipsis;
        -o-text-overflow: ellipsis;
        max-width: 15rem;
        margin-right: auto;
        margin-left: auto;
    }
    td > .loading{
        max-width: 100% !important;
    }
    
    tbody {
      display:block;
      max-height:60vh;
      min-width: 1000px;
    }
    tr {
      display:table;
      table-layout:fixed;
      width: 100%;
    }
    table.ck-table.modal  tbody {
      display:block;
      max-height:60vh;
      min-width: 700px;
    }

    .td-titles td{
        padding-top:1px !important;
        padding-bottom:1px !important;
        background: #f6f6f6;
    }

    .td-short td{
        padding-top:1px !important;
        padding-bottom:1px !important;
        background: #fdfcfc;
    }

    tbody > div {
        vertical-align: middle !important;
    }
    
</style>